export default "__VITE_ASSET__DKjijuaa__"